const theme = {
  primaryColor100: "#7362ff",
  primaryColor80: "#a99fee",
  gray80: "#7D7D7D",
};

export default theme;
